import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ModalFooter } from 'reactstrap';

const WizardModalFooter = ({ onCancel, cancelDisabled = false, showCancel = true, children }) => {
    const { t } = useTranslation();

    return (
        <ModalFooter className="wizard-modal-footer d-flex flex-wrap align-items-center">
            {showCancel && onCancel ? (
                <Button color="secondary" disabled={cancelDisabled} onClick={onCancel}>
                    <i className="fa fa-close"></i>&nbsp;{t('common.cancel')}
                </Button>
            ) : null}
            {children ? (
                <div className="ml-auto d-flex flex-wrap align-items-center">
                    {children}
                </div>
            ) : null}
        </ModalFooter>
    );
};

export default WizardModalFooter;
